export default "__VITE_ASSET__Pk5Vqbmt__"